import React, { useEffect, useState } from "react";
import uploadIcon from "../../assets/images/upload-icon.svg";
import Footer from "../common/Footer";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import {
  basicDetailsRules,
} from "../../utils/basicDetailsValidation";
import { GetStateList, uploadFileService } from "../../api/common";
import { EMAIL_REGEX } from "../../config/constant";
import OtpVerifyModal from "../ui/OtpVerifyModal";
import OTPInput from "react-otp-input";
import {
  RegisterStepOne,
  verifyEmailService,
  verifyMobileService,
  verifyOtpService,
} from "../../api/Register";
import { tostE, tostS, tostW } from "../../config/tostConfig";
import { useDispatch, useSelector } from "react-redux";
import { setProcessData, setStepData } from "../../redux/actions/processAction";
import { useParams } from "react-router-dom";
import { uploadInlineIcon } from "../../assets/images";
import moment from "moment";
import { formatIndianNumber, truncateFilename } from "../../utils/commonFunction";
import borderResolutionSample from "../../assets/pdf/board_resolution_sample.pdf"
import caCertifcateSample from "../../assets/pdf/ca_certificate_sample.pdf"

export default function BasicDetailsCp({
  handleBack = () => { },
  handleNext = () => { },
  invalidForm = false,
  setInValidForm = () => { },
}) {
  const { user_id } = useParams();
  const dispatch = useDispatch();
  const { currentMembership, data } = useSelector((state) => state.process);
  const {
    email,
    mobile_number,
    email_verified,
    mobile_verified,
    id,
    plan_history,
  } = useSelector((state) => state.process.data);

  const zoneOption = ["North", "East", "West", "South"];
  const companyTypeOption = [
    { value: "company", label: "Private Limited / Limited company" },
    { value: "partnership", label: "Partnership Firm / LLP" },
    { value: "huf", label: "Proprietor / HUF" },
  ];
  const [stateOption, setStateOption] = useState([]);
  const [emailModal, setEmailModal] = useState(false);
  const [mobileModal, setMobileModal] = useState(false);
  const [showEmailVerify, setShowEmailVerify] = useState(false);
  const [showMobileVerify, setShowMobileVerify] = useState(false);
  const [otp, setOtp] = useState("");
  const [mobileotp, setMobileOtp] = useState("");
  const [loading, setLoading] = useState("");

  const getStateList = async (zone) => {
    try {
      const res = await GetStateList(zone);
      if (res.status === 200) {
        const respData = res.data;
        setStateOption(respData);
        if (data.state) {
          const isExist =
            respData.filter(
              (item) => item.id.toString() === data.state.toString()
            ).length > 0;
          if (!isExist) {
            setFieldValue("state", "");
            dispatch(setProcessData({ state: "" }));
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const validationSchema = Yup.object().shape({
    ...basicDetailsRules(currentMembership),
  });

  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      name: data.name ? data.name : "",
      email: data.email ? data.email : "",
      dob: data.dob ? data.dob : "",
      mobile_number: data.mobile_number ? data.mobile_number : "",
      state: data.state ?? "",
      zone: data.zone ? data.zone : "",
      gst_number:
        data.gst_number &&
          data.gst_number !== null &&
          data.gst_number !== "null"
          ? data.gst_number
          : "",
      gst_proof: data.gst_proof ? data.gst_proof : "",
      aadhar_proof: data.aadhar_proof ? data.aadhar_proof : "",
      pan_proof: data.pan_proof ? data.pan_proof : "",
      pan_number: data.pan_number ? data.pan_number : "",
      org_type: data.org_type ? data.org_type : "",
      company_name: data.company_name ? data.company_name : "",
      registered_address: data.registered_address
        ? data.registered_address
        : "",
      incorporation_date: data.incorporation_date
        ? data.incorporation_date
        : "",
      size_of_company: data.size_of_company ? data.size_of_company : "",
      primary_number: data.primary_number
        ? data.primary_number
        : data.same_number
          ? data.mobile_number
          : "",
      same_number: data.same_number ? data.same_number : 0,
      moa: data.company && data.company.moa ? data.company.moa : "",
      aoa: data.company && data.company.aoa ? data.company.aoa : "",
      portaldirector:
        data.company && data.company.portaldirector
          ? data.company.portaldirector
          : "",
      resolution:
        data.company && data.company.resolution ? data.company.resolution : "",
      incorporation_certificate: data.incorporation_certificate
        ? data.incorporation_certificate
        : "",
      repersentative_photo: data.repersentative_photo
        ? data.repersentative_photo
        : "",
      deed: data.llp && data.llp.deed ? data.llp.deed : "",
      authorization:
        data.llp && data.llp.authorization ? data.llp.authorization : "",
      huf_deed: data.huf && data.huf.deed ? data.huf.deed : "",
      huf_authorization:
        data.huf && data.huf.authorization ? data.huf.authorization : "",
      address_proof: data.address_proof ? data.address_proof : "",
      turn_over_amount: data.turn_over_amount ? data.turn_over_amount : "",
      turn_over_year: data.turn_over_year ? data.turn_over_year : "",
      turn_over_year_2: data.turn_over_year_2 ? data.turn_over_year_2 : "",
      turn_over_amount_2: data.turn_over_amount_2 ? data.turn_over_amount_2 : "",
      turnover_certificate: data.turnover_certificate
        ? data.turnover_certificate
        : "",
    },
    validationSchema,
    onSubmit: async (values) => {
      if (!email_verified || values.email !== email) {
        tostW("Please verify your email");
        return;
      }
      if (
        !mobile_verified ||
        values.mobile_number.toString() !== mobile_number.toString()
      ) {
        tostW("Please verify your mobile number");
        return;
      }
      setLoading("submit");
      let formData = new FormData();
      if (id) {
        formData.set("id", id);
      }
      formData.set("name", values.name);
      formData.set("email", values.email);
      formData.set("dob", moment(values.dob).format("YYYY-MM-DD"));
      formData.set("mobile_number", values.mobile_number);
      formData.set("state", values.state);
      formData.set("zone", values.zone);
      formData.set("gst_number", values.gst_number);
      formData.set("pan_number", values.pan_number);
      formData.set("company_name", values.company_name);
      formData.set("registered_address", values.registered_address);
      formData.set("size_of_company", values.size_of_company);
      formData.set("primary_number", values.primary_number);
      formData.set("same_number", values.same_number);
      formData.set("is_admin", 1);
      formData.set("aadhar_proof", values.aadhar_proof);
      formData.set("pan_proof", values.pan_proof);

      if (
        currentMembership &&
        currentMembership.name.toLowerCase() !== "star"
      ) {
        formData.set("org_type", values.org_type);
        formData.set(
          "incorporation_date",
          moment(values.incorporation_date).format("YYYY-MM-DD")
        );
        formData.set("gst_proof", values.gst_proof);
        formData.set("turnover_certificate", values.turnover_certificate);
        if (values.org_type.toLowerCase() === "company") {
          formData.set("moa", values.moa);
          formData.set("aoa", values.aoa);
          formData.set("portaldirector", values.portaldirector);
          formData.set("resolution", values.resolution);
          formData.set(
            "incorporation_certificate",
            values.incorporation_certificate
          );
        }
        if (values.org_type.toLowerCase() === "partnership") {
          formData.set("deed", values.deed);
          formData.set("authorization", values.authorization);
        }
        if (values.org_type.toLowerCase() === "huf") {
          formData.set("deed", values.huf_deed);
          formData.set("authorization", values.huf_authorization);
        }
      }
      formData.set("repersentative_photo", values.repersentative_photo);
      formData.set("address_proof", values.address_proof);

      if (
        currentMembership &&
        currentMembership.name.toLowerCase() !== "star"
      ) {
        formData.set("turn_over_amount", values.turn_over_amount);
        formData.set("turn_over_year", values.turn_over_year);
        formData.set("turn_over_amount_2", values.turn_over_amount_2);
        formData.set("turn_over_year_2", values.turn_over_year_2);
      }

      formData.set(
        "membership_id",
        currentMembership ? currentMembership.id : plan_history.plan_id
      );
      formData.set("journey", data.history_type ? data.history_type : "new");

      if (data.app_id) {
        formData.set("app_id", data.app_id);
      }

      try {
        const res = await RegisterStepOne(formData);
        if (res.status === 200 && res.data.success) {
          tostS(res.data.message);
          dispatch(setStepData(2));
          handleNext();
        } else {
          tostW(res.data.message);
        }
      } catch (error) {
        tostE(error.message);
      } finally {
        setLoading("");
      }
    },
  });

  const {
    values,
    touched,
    errors,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    setErrors,
    setTouched,
    validateForm,
  } = formik;

  useEffect(() => {
    if (invalidForm) {
      validateForm().then((validationErrors) => {
        if (Object.keys(validationErrors).length > 0) {
          setErrors(validationErrors);
          setTouched(
            Object.keys(validationErrors).reduce(
              (acc, key) => ({ ...acc, [key]: true }),
              {}
            )
          );
        }
      });
      setInValidForm(false);
    }
  }, [validateForm]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFileUpload = async (e) => {
    const fieldName = e.target.name;
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    const validFileTypes = {
      address_proof: [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "image/jpg",
      ],
      repersentative_photo: ["image/jpeg", "image/png", "image/jpg"],
      default: ["application/pdf"],
    };

    const allowedTypes = validFileTypes[fieldName] || validFileTypes.default;
    if (!allowedTypes.includes(file.type)) {
      tostW(
        `Only ${allowedTypes
          .map((type) => type.split("/")[1].toUpperCase())
          .join(", ")} files are allowed.`
      );
      return;
    }

    // Validate file size (5 MB)
    const maxSizeInBytes = 5 * 1024 * 1024;
    const turnoverMaxSizeInBytes = 20 * 1024 * 1024;
    if (
      fieldName === "turnover_certificate" &&
      file.size > turnoverMaxSizeInBytes
    ) {
      tostW("File size must upto 20 MB.");
      return;
    } else if (file.size > maxSizeInBytes) {
      tostW("File size must be upto 5 MB.");
      return;
    }

    // Prepare form data for file upload
    const body = new FormData();
    body.append("file", file);
    if (values[fieldName]) {
      body.append("old_file_name", values[fieldName].split(".com").pop());
    }

    try {
      const fileResponse = await uploadFileService(body);
      if (fileResponse.status === 200 && fileResponse.data.success) {
        const uploadedFileUrl = fileResponse.data.url;
        setFieldValue(fieldName, uploadedFileUrl);

        const companyField = ["moa", "aoa", "portaldirector", "resolution"];
        const llpField = ["deed", "authorization"];
        const hufField = ["huf_deed", "huf_authorization"];

        const updatedData = {
          ...data,
          company: companyField.includes(fieldName)
            ? { ...data.company, [fieldName]: uploadedFileUrl }
            : data.company,
          llp: llpField.includes(fieldName)
            ? { ...data.llp, [fieldName]: uploadedFileUrl }
            : data.llp,
          huf: hufField.includes(fieldName)
            ? {
              ...data.huf,
              [fieldName.toString().replace("huf_", "")]: uploadedFileUrl,
            }
            : data.huf,
          [fieldName]:
            !companyField.includes(fieldName) &&
              !llpField.includes(fieldName) &&
              !hufField.includes(fieldName)
              ? uploadedFileUrl
              : data[fieldName],
        };

        dispatch(setProcessData(updatedData));
      }
    } catch (error) {
      console.error(error);
      tostW("Error uploading file");
    }
  };

  const handleVerifyEmail = async () => {
    if (loading === "verify_email") return;
    if (values.email && EMAIL_REGEX.test(values.email)) {
      setLoading("verify_email");
      try {
        const res = await verifyEmailService(values.email);
        if (res.status === 200 && res.data.success) {
          setEmailModal(true);
        } else {
          tostW(res.data.message);
        }
      } catch (error) {
        tostE(error.message);
      } finally {
        setLoading("");
      }
    } else {
      setFieldTouched("email", true);
    }
  };

  const handleVerifyMobile = async () => {
    if (loading === "verify_mobile") return;
    if (values.mobile_number && values.mobile_number.toString().length >= 6) {
      setLoading("verify_mobile");
      try {
        const res = await verifyMobileService(values.mobile_number);
        if (res.status === 200 && res.data.success) {
          setMobileModal(true);
        } else {
          tostW(res.data.message);
        }
      } catch (error) {
        tostE(error.message);
      } finally {
        setLoading("");
      }
    } else {
      setFieldTouched("mobile_number", true);
    }
  };

  const handleVerifyOtp = async (type) => {
    if (loading === "verify_email_otp" || loading === "verify_mobile_otp")
      return;
    if (type === "email") {
      if (!otp || otp.toString().length < 4) {
        tostW("Please enter a valid OTP");
        return;
      }
      setLoading("verify_email_otp");
      const body = {
        email: values.email,
        otp: otp,
      };
      try {
        const res = await verifyOtpService(body);
        if (res.status === 200 && res.data.success) {
          dispatch(
            setProcessData({ email: values.email, email_verified: true })
          );
          setEmailModal(false);
          setOtp("");
        } else {
          setShowEmailVerify(true);
          tostW("OTP verification failed");
        }
      } catch (error) {
        setShowEmailVerify(true);
        console.log(error);
      } finally {
        setLoading("");
      }
    }
    if (type === "mobile") {
      if (!mobileotp || mobileotp.toString().length < 4) {
        tostW("Please enter a valid OTP");
        return;
      }
      const body = {
        mobile_number: values.mobile_number,
        otp: mobileotp,
      };
      setLoading("verify_mobile_otp");
      try {
        const res = await verifyOtpService(body);
        if (res.status === 200 && res.data.success) {
          dispatch(
            setProcessData({
              mobile_number: values.mobile_number,
              mobile_verified: true,
            })
          );
          setMobileModal(false);
          setOtp("");
        } else {
          setShowMobileVerify(true);
          tostW("OTP verification failed");
        }
      } catch (error) {
        setShowMobileVerify(true);
        console.log(error);
      } finally {
        setLoading("");
      }
    }
  };

  useEffect(() => {
    if (otp && otp.toString().length === 4) {
      if (emailModal) {
        handleVerifyOtp("email");
      }
    }
  }, [otp]); // eslint-disable-line

  useEffect(() => {
    if (mobileotp && mobileotp.toString().length === 4) {
      if (mobileModal) {
        handleVerifyOtp("mobile");
      }
    }
  }, [mobileotp]); // eslint-disable-line

  useEffect(() => {
    if (data.zone) {
      getStateList(data.zone.toLowerCase());
    }
  }, [data.zone]); // eslint-disable-line

  return (
    <>
      <div className="membershipForm">
        <FormikProvider value={formik}>
          <Form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Full Name"
                    name="name"
                    // disabled={(id) ? true : false}
                    value={values.name}
                    onChange={(e) => {
                      setFieldValue("name", e.target.value);
                      dispatch(setProcessData({ name: e.target.value }));
                    }}
                  />
                  {touched.name && errors.name && (
                    <div className="error">{errors.name}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className={"verifyLabel "}>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address"
                      name="email"
                      // disabled={(id) ? true : false}
                      value={values.email}
                      onChange={(e) => {
                        setFieldValue("email", e.target.value);
                        if (!email_verified) {
                          dispatch(setProcessData({ email: e.target.value }));
                        }
                      }}
                    />
                    {console.log(
                      "email_verified",
                      email_verified,
                      values.email,
                      email
                    )}
                    <span
                      onClick={() => {
                        handleVerifyEmail();
                      }}
                      className={
                        "textVerify " +
                        (loading === "verify_email" ? " loading" : "") +
                        (email_verified && values.email === email
                          ? " success"
                          : "")
                      }
                    >
                      {email_verified && values.email === email
                        ? "Verified"
                        : "Verify"}
                      {loading === "verify_email" && (
                        <div
                          className="spinner-border text-light"
                          style={{
                            width: "1rem",
                            height: "1rem",
                            marginLeft: "5px",
                          }}
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                    </span>
                  </div>
                  {touched.email && errors.email && (
                    <div className="error">{errors.email}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    className="form-control customDatePicker"
                    type={data.dob ? "date" : "text"}
                    // disabled={(id) ? true : false}
                    name="dob"
                    autoComplete="off"
                    value={values.dob ? values.dob : ""}
                    onChange={(e) => {
                      if (e.target.value.length > 10) return;
                      setFieldValue("dob", e.target.value);
                      try {
                        const validDate = moment(
                          e.target.value,
                          "YYYY-MM-DD",
                          true
                        ).isValid();
                        if (validDate) {
                          dispatch(
                            setProcessData({
                              dob: moment(e.target.value).format("YYYY-MM-DD"),
                            })
                          );
                        }
                      } catch (err) {
                        console.log(err);
                      }
                    }}
                    placeholder="Date of Birth (DD/MM/YYYY)"
                    aria-label="select date of birth"
                    onFocus={(e) => {
                      if (e.target.value) {
                        e.target.type = "date";
                      } else {
                        e.target.type = "date";
                      }
                    }}
                    onBlur={(e) => {
                      if (!e.target.value) {
                        e.target.type = "text";
                      } else {
                        e.target.type = "date";
                      }
                    }}
                  />
                  {touched.dob && errors.dob && (
                    <div className="error">{errors.dob}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className={"verifyLabel "}>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Whatsapp Number"
                      name="mobile_number"
                      // disabled={(id) ? true : false}
                      value={values.mobile_number}
                      onChange={(e) => {
                        if (e.target.value.toString().length > 15) {
                          return;
                        }
                        setFieldValue("mobile_number", e.target.value);
                        if (values.same_number) {
                          setFieldValue("primary_number", e.target.value);
                        }
                        if (!mobile_verified) {
                          dispatch(
                            setProcessData({ mobile_number: e.target.value })
                          );
                        }
                      }}
                    />
                    <span
                      onClick={() => handleVerifyMobile()}
                      className={
                        "textVerify " +
                        (loading === "verify_mobile" ? " loading" : "") +
                        (mobile_verified &&
                          values.mobile_number &&
                          mobile_number &&
                          values.mobile_number.toString() ===
                          mobile_number.toString()
                          ? " success"
                          : "")
                      }
                    >
                      {mobile_verified &&
                        values.mobile_number &&
                        mobile_number &&
                        values.mobile_number.toString() ===
                        mobile_number.toString()
                        ? "Verified"
                        : "Verify"}
                      {loading === "verify_mobile" && (
                        <div
                          className="spinner-border text-light"
                          style={{
                            width: "1rem",
                            height: "1rem",
                            marginLeft: "5px",
                          }}
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                    </span>
                  </div>
                  {touched.mobile_number && errors.mobile_number && (
                    <div className="error">{errors.mobile_number}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className={"verifyLabel "}>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Primary Mobile Number"
                      name="primary_number"
                      disabled={values.same_number === 1 ? true : false}
                      value={values.primary_number}
                      onChange={(e) => {
                        if (e.target.value.toString().length > 15) {
                          return;
                        }
                        setFieldValue("primary_number", e.target.value);
                        dispatch(
                          setProcessData({ primary_number: e.target.value })
                        );
                      }}
                    />
                  </div>
                  {touched.primary_number && errors.primary_number && (
                    <div className="error">{errors.primary_number}</div>
                  )}
                  <span className="form-check numberCheck">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="inlineCheckbox1"
                      name="same_number"
                      // disabled={(id) ? true : false}
                      checked={values.same_number === 1}
                      onChange={(e) => {
                        if (
                          !values.mobile_number ||
                          values.mobile_number.toString() === ""
                        ) {
                          tostW("Please enter your whatsapp number first.");
                          return;
                        }
                        if (mobile_verified) {
                          setFieldValue(
                            "same_number",
                            e.target.checked ? 1 : 0
                          );
                          dispatch(
                            setProcessData({
                              same_number: e.target.checked ? 1 : 0,
                            })
                          );
                          if (e.target.checked) {
                            setFieldValue(
                              "primary_number",
                              values.mobile_number
                            );
                            dispatch(
                              setProcessData({
                                primary_number: values.mobile_number,
                              })
                            );
                          } else {
                            setFieldValue("primary_number", "");
                            dispatch(setProcessData({ primary_number: "" }));
                          }
                        } else {
                          e.target.checked = false;
                          tostW("Please verify your whatsapp number first.");
                        }
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="inlineCheckbox1"
                    >
                      Primary Mobile Number is same as Whatsapp Number.
                    </label>
                  </span>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="customSelect">
                    <select
                      className={
                        "form-control " + (values.zone ? "" : " not-selected")
                      }
                      name={"zone"}
                      value={values.zone}
                      onChange={(e) => {
                        setFieldValue("zone", e.target.value);
                        dispatch(setProcessData({ zone: e.target.value }));
                      }}
                    // disabled={(id) ? true : false}
                    >
                      <option value="">{"Select Zone"}</option>
                      {zoneOption.map((option, idx) => (
                        <option key={idx} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  {touched.zone && errors.zone && (
                    <div className="error">{errors.zone}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="customSelect">
                    <select
                      className={
                        "form-control " + (values.state ? "" : " not-selected")
                      }
                      name={"state"}
                      value={values.state}
                      onChange={(e) => {
                        setFieldValue("state", e.target.value);
                        dispatch(setProcessData({ state: e.target.value }));
                      }}
                    // disabled={(id) ? true : false}
                    >
                      <option value="">Select State</option>
                      {stateOption.map((option, idx) => (
                        <option key={idx} value={option.id}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {touched.state && errors.state && (
                    <div className="error">{errors.state}</div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={
                      "GST Number" +
                      (currentMembership?.name.toString().toLowerCase() ===
                        "star"
                        ? " (Optional)"
                        : "")
                    }
                    name="gst_number"
                    // disabled={(id) ? true : false}
                    value={values.gst_number}
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase().trim();
                      if (value.length > 15) return;
                      setFieldValue("gst_number", value);
                      dispatch(setProcessData({ gst_number: value }));
                    }}
                  />
                  {touched.gst_number && errors.gst_number && (
                    <div className="error">{errors.gst_number}</div>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <div className="customFile inline">
                    <input
                      name="gst_proof"
                      onChange={(e) => handleFileUpload(e)}
                      className="form-control"
                      type="file"
                      accept="application/pdf"
                      title={
                        values.gst_proof
                          ? values.gst_proof.name ||
                          values.gst_proof.split("/").pop()
                          : "GST Document"
                      }
                    />
                    <span>
                      <p>
                        {values.gst_proof
                          ? truncateFilename(
                            values.gst_proof.name ||
                            values.gst_proof.split("/").pop()
                          )
                          : "GST Document"}
                        {currentMembership?.name.toString().toLowerCase() === "star"
                          ? " (Optional)"
                          : ""}
                      </p>
                      <small>
                        Please upload only pdf files (Max size: 5MB)
                      </small>
                    </span>
                    <img src={uploadInlineIcon} alt="" />
                  </div>
                  {touched.gst_proof && errors.gst_proof && (
                    <div className="error">{errors.gst_proof}</div>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <div className="customFile inline">
                    <input
                      name="aadhar_proof"
                      onChange={(e) => handleFileUpload(e)}
                      className="form-control"
                      type="file"
                      accept="application/pdf"
                      title={
                        values.aadhar_proof
                          ? values.aadhar_proof.name ||
                          values.aadhar_proof.split("/").pop()
                          : "Aadhar Card"
                      }
                    />
                    <span>
                      <p>
                        {values.aadhar_proof
                          ? truncateFilename(
                            values.aadhar_proof.name ||
                            values.aadhar_proof.split("/").pop()
                          )
                          : "Aadhar Card"}
                      </p>
                      <small>
                        Please upload only pdf files (Max size: 5MB)
                      </small>
                    </span>
                    <img src={uploadInlineIcon} alt="" />
                  </div>
                  {touched.aadhar_proof && errors.aadhar_proof && (
                    <div className="error">{errors.aadhar_proof}</div>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="PAN Number"
                    name="pan_number"
                    value={values.pan_number}
                    // disabled={(id) ? true : false}
                    onChange={(e) => {
                      const value = e.target.value.toUpperCase().trim();
                      if (value.length > 10) return;
                      setFieldValue("pan_number", value);
                      dispatch(setProcessData({ pan_number: value }));
                    }}
                  />
                  {touched.pan_number && errors.pan_number && (
                    <div className="error">{errors.pan_number}</div>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <div className="customFile inline">
                    <input
                      name="pan_proof"
                      onChange={(e) => handleFileUpload(e)}
                      className="form-control"
                      type="file"
                      accept="application/pdf"
                      title={
                        values.pan_proof
                          ? values.pan_proof.name ||
                          values.pan_proof.split("/").pop()
                          : "PAN Card"
                      }
                    />
                    <span>
                      <p>
                        {values.pan_proof
                          ? truncateFilename(
                            values.pan_proof.name ||
                            values.pan_proof.split("/").pop()
                          )
                          : "PAN Card"}
                      </p>
                      <small>
                        Please upload only pdf files (Max size: 5MB)
                      </small>
                    </span>
                    <img src={uploadInlineIcon} alt="" />
                  </div>
                  {touched.pan_proof && errors.pan_proof && (
                    <div className="error">{errors.pan_proof}</div>
                  )}
                </div>
              </div>
              {currentMembership &&
                currentMembership?.name.toString().toLowerCase() !== "star" && (
                  <>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customSelect">
                          <select
                            className={
                              "form-control " +
                              (values.org_type ? "" : " not-selected")
                            }
                            name={"org_type"}
                            value={values.org_type}
                            onChange={(e) => {
                              setFieldValue("org_type", e.target.value);
                              dispatch(
                                setProcessData({ org_type: e.target.value })
                              );
                            }}
                          // disabled={(id) ? true : false}
                          >
                            <option value="">{"Select Company Type"}</option>
                            {companyTypeOption.map((option, idx) => (
                              <option key={idx} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        {touched.org_type && errors.org_type && (
                          <div className="error">{errors.org_type}</div>
                        )}
                      </div>
                    </div>
                    {values.org_type && values.org_type !== "huf" && (
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            className="form-control customDatePicker"
                            type={data.incorporation_date ? "date" : "text"}
                            // disabled={(id) ? true : false}
                            name="incorporation_date"
                            autoComplete="off"
                            value={
                              values.incorporation_date
                                ? values.incorporation_date
                                : ""
                            }
                            onChange={(e) => {
                              if (e.target.value.length > 10) return;
                              setFieldValue(
                                "incorporation_date",
                                e.target.value
                              );
                              try {
                                const validDate = moment(
                                  e.target.value,
                                  "YYYY-MM-DD",
                                  true
                                ).isValid();
                                if (validDate) {
                                  dispatch(
                                    setProcessData({
                                      incorporation_date: moment(
                                        e.target.value
                                      ).format("YYYY-MM-DD"),
                                    })
                                  );
                                }
                              } catch (err) {
                                console.log(err);
                              }
                            }}
                            placeholder="Incorporation Date (DD/MM/YYYY)"
                            aria-label="select Incorporation Date"
                            onFocus={(e) => {
                              if (e.target.value) {
                                e.target.type = "date";
                              } else {
                                e.target.type = "date";
                              }
                            }}
                            onBlur={(e) => {
                              if (!e.target.value) {
                                e.target.type = "text";
                              } else {
                                e.target.type = "date";
                              }
                            }}
                          />
                          {touched.incorporation_date &&
                            errors.incorporation_date && (
                              <div className="error">
                                {errors.incorporation_date}
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                  </>
                )}
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Company Name"
                    name="company_name"
                    value={values.company_name}
                    // disabled={(id) ? true : false}
                    onChange={(e) => {
                      setFieldValue("company_name", e.target.value);
                      dispatch(
                        setProcessData({ company_name: e.target.value })
                      );
                    }}
                  />
                  {touched.company_name && errors.company_name && (
                    <div className="error">{errors.company_name}</div>
                  )}
                </div>
              </div>
              {currentMembership &&
                currentMembership?.name.toString().toLowerCase() !== "star" && (
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="customSelect">
                        <select
                          className={
                            "form-control " +
                            (values.size_of_company ? "" : " not-selected")
                          }
                          name={"size_of_company"}
                          value={values.size_of_company}
                          onChange={(e) => {
                            setFieldValue("size_of_company", e.target.value);
                            dispatch(
                              setProcessData({
                                size_of_company: e.target.value,
                              })
                            );
                          }}
                        // disabled={(id) ? true : false}
                        >
                          <option value="">{"Select Company Size"}</option>
                          {["1-25", "25-50", "50 & above"].map(
                            (option, idx) => (
                              <option key={idx} value={option}>
                                {option}
                              </option>
                            )
                          )}
                        </select>
                      </div>
                      {touched.size_of_company && errors.size_of_company && (
                        <div className="error">{errors.size_of_company}</div>
                      )}
                    </div>
                  </div>
                )}
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Registered Office Address"
                    name="registered_address"
                    value={values.registered_address}
                    // disabled={(id) ? true : false}
                    onChange={(e) => {
                      setFieldValue("registered_address", e.target.value);
                      dispatch(
                        setProcessData({ registered_address: e.target.value })
                      );
                    }}
                  />
                  {touched.registered_address && errors.registered_address && (
                    <div className="error">{errors.registered_address}</div>
                  )}
                </div>
              </div>
              {currentMembership &&
                currentMembership?.name.toString().toLowerCase() !== "star" &&
                values.org_type === "company" && (
                  <>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customFile inline">
                          <input
                            name="moa"
                            onChange={(e) => handleFileUpload(e)}
                            className="form-control"
                            type="file"
                            accept="application/pdf"
                            title={
                              values.moa
                                ? values.moa.name || values.moa.split("/").pop()
                                : "Upload MOA"
                            }
                          />
                          <span>
                            <p>
                              {values.moa
                                ? truncateFilename(
                                  values.moa.name ||
                                  values.moa.split("/").pop()
                                )
                                : "Upload MOA"}
                            </p>
                            <small>
                              Please upload only pdf files (Max size: 5MB)
                            </small>
                          </span>
                          <img src={uploadInlineIcon} alt="" />
                        </div>
                        {touched.moa && errors.moa && (
                          <div className="error">{errors.moa}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customFile inline">
                          <input
                            name="aoa"
                            onChange={(e) => handleFileUpload(e)}
                            className="form-control"
                            type="file"
                            accept="application/pdf"
                            title={
                              values.aoa
                                ? values.aoa.name || values.aoa.split("/").pop()
                                : "Upload AOA"
                            }
                          />
                          <span>
                            <p>
                              {values.aoa
                                ? truncateFilename(
                                  values.aoa.name ||
                                  values.aoa.split("/").pop()
                                )
                                : "Upload AOA"}
                            </p>
                            <small>
                              Please upload only pdf files (Max size: 5MB)
                            </small>
                          </span>
                          <img src={uploadInlineIcon} alt="" />
                        </div>
                        {touched.aoa && errors.aoa && (
                          <div className="error">{errors.aoa}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customFile inline">
                          <input
                            name="portaldirector"
                            onChange={(e) => handleFileUpload(e)}
                            className="form-control"
                            type="file"
                            accept="application/pdf"
                            title={
                              values.portaldirector
                                ? values.portaldirector.name ||
                                values.portaldirector.split("/").pop()
                                : "Director details from MCA Portal"
                            }
                          />
                          <span>
                            <p>
                              {values.portaldirector
                                ? truncateFilename(
                                  values.portaldirector.name ||
                                  values.portaldirector.split("/").pop()
                                )
                                : "Director details from MCA Portal"}
                            </p>
                            <small>
                              Please upload only pdf files (Max size: 5MB)
                            </small>
                          </span>
                          <img src={uploadInlineIcon} alt="" />
                        </div>
                        {touched.portaldirector && errors.portaldirector && (
                          <div className="error">{errors.portaldirector}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customFile inline">
                          <input
                            name="resolution"
                            onChange={(e) => handleFileUpload(e)}
                            className="form-control"
                            type="file"
                            accept="application/pdf"
                            title={
                              values.resolution
                                ? values.resolution.name ||
                                values.resolution.split("/").pop()
                                : "Board Resolution"
                            }
                          />
                          <span>
                            <p>
                              {values.resolution
                                ? truncateFilename(
                                  values.resolution.name ||
                                  values.resolution.split("/").pop()
                                )
                                : "Board Resolution"}
                            </p>
                            <small>
                              Please upload only pdf files (Max size: 5MB)
                            </small>
                          </span>
                          <img src={uploadInlineIcon} alt="" />
                        </div>
                        {touched.resolution && errors.resolution && (
                          <div className="error">{errors.resolution}</div>
                        )}
                        <a href={borderResolutionSample} style={{color:'black', textDecoration: 'underline', fontSize: '14px', display:'block', marginTop:'10px'}} target='_blank' rel='noopener noreferrer'>Board Resolution Sample File</a>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customFile inline">
                          <input
                            name="incorporation_certificate"
                            onChange={(e) => handleFileUpload(e)}
                            className="form-control"
                            type="file"
                            accept="application/pdf"
                            title={
                              values.incorporation_certificate
                                ? values.incorporation_certificate.name ||
                                values.incorporation_certificate
                                  .split("/")
                                  .pop()
                                : "Incorporation Certificate"
                            }
                          />
                          <span>
                            <p>
                              {values.incorporation_certificate
                                ? truncateFilename(
                                  values.incorporation_certificate.name ||
                                  values.incorporation_certificate
                                    .split("/")
                                    .pop()
                                )
                                : "Incorporation Certificate"}
                            </p>
                            <small>
                              Please upload only pdf files (Max size: 5MB)
                            </small>
                          </span>
                          <img src={uploadInlineIcon} alt="" />
                        </div>
                        {touched.incorporation_certificate &&
                          errors.incorporation_certificate && (
                            <div className="error">
                              {errors.incorporation_certificate}
                            </div>
                          )}
                      </div>
                    </div>
                  </>
                )}
              {currentMembership &&
                currentMembership?.name.toString().toLowerCase() !== "star" &&
                values.org_type === "partnership" && (
                  <>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customFile inline">
                          <input
                            name="deed"
                            onChange={(e) => handleFileUpload(e)}
                            className="form-control"
                            type="file"
                            accept="application/pdf"
                            title={
                              values.deed
                                ? values.deed.name ||
                                values.deed.split("/").pop()
                                : "Partnership Deed"
                            }
                          />
                          <span>
                            <p>
                              {values.deed
                                ? truncateFilename(
                                  values.deed.name ||
                                  values.deed.split("/").pop()
                                )
                                : "Partnership Deed"}
                            </p>
                            <small>
                              Please upload only pdf files (Max size: 5MB)
                            </small>
                          </span>
                          <img src={uploadInlineIcon} alt="" />
                        </div>
                        {touched.deed && errors.deed && (
                          <div className="error">{errors.deed}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customFile inline">
                          <input
                            name="authorization"
                            onChange={(e) => handleFileUpload(e)}
                            className="form-control"
                            type="file"
                            accept="application/pdf"
                            title={
                              values.authorization
                                ? values.authorization.name ||
                                values.authorization.split("/").pop()
                                : "Authorization Letter"
                            }
                          />
                          <span>
                            <p>
                              {values.authorization
                                ? truncateFilename(
                                  values.authorization.name ||
                                  values.authorization.split("/").pop()
                                )
                                : "Authorization Letter"}
                            </p>
                            <small>
                              Please upload only pdf files (Max size: 5MB)
                            </small>
                          </span>
                          <img src={uploadInlineIcon} alt="" />
                        </div>
                        {touched.authorization && errors.authorization && (
                          <div className="error">{errors.authorization}</div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              {currentMembership &&
                currentMembership?.name.toString().toLowerCase() !== "star" &&
                values.org_type === "huf" && (
                  <>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customFile inline">
                          <input
                            name="huf_deed"
                            onChange={(e) => handleFileUpload(e)}
                            className="form-control"
                            type="file"
                            accept="application/pdf"
                            title={
                              values.huf_deed
                                ? values.huf_deed.name ||
                                values.huf_deed.split("/").pop()
                                : "HUF Deed (Optional)"
                            }
                          />
                          <span>
                            <p>
                              {values.huf_deed
                                ? truncateFilename(
                                  values.huf_deed.name ||
                                  values.huf_deed.split("/").pop()
                                )
                                : "HUF Deed (Optional)"}
                            </p>
                            <small>
                              Please upload only pdf files (Max size: 5MB)
                            </small>
                          </span>
                          <img src={uploadInlineIcon} alt="" />
                        </div>
                        {touched.huf_deed && errors.huf_deed && (
                          <div className="error">{errors.huf_deed}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customFile inline">
                          <input
                            name="huf_authorization"
                            onChange={(e) => handleFileUpload(e)}
                            className="form-control"
                            type="file"
                            accept="application/pdf"
                            title={
                              values.huf_authorization
                                ? values.huf_authorization.name ||
                                values.huf_authorization.split("/").pop()
                                : "Authorization Letter"
                            }
                          />
                          <span>
                            <p>
                              {values.huf_authorization
                                ? truncateFilename(
                                  values.huf_authorization.name ||
                                  values.huf_authorization.split("/").pop()
                                )
                                : "Authorization Letter"}
                            </p>
                            <small>
                              Please upload only pdf files (Max size: 5MB)
                            </small>
                          </span>
                          <img src={uploadInlineIcon} alt="" />
                        </div>
                        {touched.huf_authorization &&
                          errors.huf_authorization && (
                            <div className="error">
                              {errors.huf_authorization}
                            </div>
                          )}
                      </div>
                    </div>
                  </>
                )}
              <div className="col-md-6">
                <div className="form-group">
                  <div className={"customFile inline"}>
                    <input
                      // disabled={(id) ? true : false}
                      name="repersentative_photo"
                      onChange={(e) => handleFileUpload(e)}
                      className="form-control"
                      type="file"
                      accept="image/*"
                      title={
                        values.repersentative_photo
                          ? values.repersentative_photo.name ||
                          values.repersentative_photo.split("/").pop()
                          : "Representative Photo"
                      }
                    />
                    <span>
                      <p>
                        {values.repersentative_photo
                          ? truncateFilename(
                            values.repersentative_photo.name ||
                            values.repersentative_photo.split("/").pop()
                          )
                          : "Representative Photo"}
                      </p>
                      <small>
                        Allowed formats: .jpg, .jpeg, .png (Max size: 5MB)
                      </small>
                    </span>
                    <img src={uploadInlineIcon} alt="" />
                  </div>
                  {touched.repersentative_photo &&
                    errors.repersentative_photo && (
                      <div className="error">{errors.repersentative_photo}</div>
                    )}
                </div>
              </div>
            </div>

            {currentMembership?.name.toString().toLowerCase() !== "star" && (
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Turnover Amount"
                        name="turn_over_amount"
                        value={formatIndianNumber(values.turn_over_amount)}
                        onChange={(e) => {
                          let val = e.target.value.replace(/,/g, "");
                          if (!/^\d*\.?\d*$/.test(val)) {
                            return;
                          }
                          if (val.includes(".")) {
                            const parts = val.split(".");
                            if (parts[1].length > 2) {
                              return;
                            }
                          }
                          setFieldValue("turn_over_amount", val);
                          dispatch(setProcessData({ turn_over_amount: val }));
                        }}
                      />
                      {/* <span className="input-group-text">CR</span> */}
                    </div>
                    {touched.turn_over_amount && errors.turn_over_amount && (
                      <div className="error">{errors.turn_over_amount}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="customSelect">
                      <select
                        className={"form-control" + (values.turn_over_year ? "" : " not-selected")}
                        name="turn_over_year"
                        value={values.turn_over_year}
                        onChange={(e) => {
                          setFieldValue("turn_over_year", e.target.value);
                          dispatch(setProcessData({ turn_over_year: e.target.value }));
                        }}
                      >
                        <option value="" disabled>Select Turnover Year</option>
                        <option value="2023-2024" disabled={values.turn_over_year_2 === "2023-2024"}>2023-2024</option>
                        <option value="2024-2025" disabled={values.turn_over_year_2 === "2024-2025"}>2024-2025</option>
                        <option value="2025-2026" disabled={values.turn_over_year_2 === "2025-2026"}>2025-2026</option>
                      </select>
                    </div>
                    {touched.turn_over_year && errors.turn_over_year && (
                      <div className="error">{errors.turn_over_year}</div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Turnover Amount"
                        name="turn_over_amount_2"
                        value={formatIndianNumber(values.turn_over_amount_2)}
                        onChange={(e) => {
                          let val = e.target.value.replace(/,/g, "");
                          if (!/^\d*\.?\d*$/.test(val)) {
                            return;
                          }
                          if (val.includes(".")) {
                            const parts = val.split(".");
                            if (parts[1].length > 2) {
                              return;
                            }
                          }
                          setFieldValue("turn_over_amount_2", val);
                          dispatch(setProcessData({ turn_over_amount_2: val }));
                        }}
                      />
                      {/* <span className="input-group-text">CR</span> */}
                    </div>
                    {touched.turn_over_amount_2 && errors.turn_over_amount_2 && (
                      <div className="error">{errors.turn_over_amount_2}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="customSelect">
                      <select
                        className={"form-control" + (values.turn_over_year_2 ? "" : " not-selected")}
                        name="turn_over_year_2"
                        value={values.turn_over_year_2}
                        onChange={(e) => {
                          setFieldValue("turn_over_year_2", e.target.value);
                          dispatch(setProcessData({ turn_over_year_2: e.target.value }));
                        }}
                      >
                        <option value="" disabled>Select Turnover Year</option>
                        <option value="2023-2024" disabled={values.turn_over_year === "2023-2024"}>2023-2024</option>
                        <option value="2024-2025" disabled={values.turn_over_year === "2024-2025"}>2024-2025</option>
                        <option value="2025-2026" disabled={values.turn_over_year === "2025-2026"}>2025-2026</option>
                      </select>
                    </div>
                    {touched.turn_over_year_2 && errors.turn_over_year_2 && (
                      <div className="error">{errors.turn_over_year_2}</div>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className="row">
              <div
                className={
                  currentMembership?.name.toString().toLowerCase() === "star"
                    ? "col-md-12"
                    : "col-md-6"
                }
              >
                <div className="form-group">
                  <div className="customFile">
                    <input
                      name="address_proof"
                      accept="image/*,application/pdf"
                      onChange={(e) => handleFileUpload(e)}
                      className="form-control"
                      type="file"
                      title={
                        values.address_proof
                          ? values.address_proof.name ||
                          values.address_proof.split("/").pop()
                          : "Rental Agreement / GST Certificate / Electricity / Broadband Bill / Udyam Certificate"
                      }
                    />
                    <img src={uploadIcon} alt="" />
                    <h4>Address Proof</h4>
                    <small className="mb-2">
                      Allowed formats: .jpg, .jpeg, .png, .pdf (Max size: 5MB)
                    </small>
                    <p>
                      {values.address_proof
                        ? truncateFilename(
                          values.address_proof.name ||
                          values.address_proof.split("/").pop(),
                          15,
                          15
                        )
                        : "Rental Agreement / GST Certificate / Electricity / Broadband Bill / Udyam Certificate"}
                    </p>
                  </div>
                  {touched.address_proof && errors.address_proof && (
                    <div className="error">{errors.address_proof}</div>
                  )}
                </div>
              </div>
              {currentMembership?.name.toString().toLowerCase() !== "star" && (
                <div className="col-md-6">
                  <div className="form-group">
                    <div className="customFile">
                      <input
                        title={
                          values.turnover_certificate
                            ? truncateFilename(
                              values.turnover_certificate.name ||
                              values.turnover_certificate.split("/").pop(),
                              15,
                              15
                            )
                            : "Upload CA Certificate / Audit report, P&L Balance Sheet"
                        }
                        name="turnover_certificate"
                        onChange={(e) => handleFileUpload(e)}
                        className="form-control"
                        type="file"
                        accept="application/pdf"
                      />
                      <img src={uploadIcon} alt="" />
                      <h4>Company Turnover</h4>
                      <small className="mb-2">
                        Please upload only pdf files (Max size: 20MB)
                      </small>
                      <p>
                        {values.turnover_certificate
                          ? values.turnover_certificate.name ||
                          values.turnover_certificate.split("/").pop()
                          : "Upload CA Certificate / Audit report, P&L Balance Sheet"}
                      </p>
                    </div>
                    {touched.turnover_certificate &&
                      errors.turnover_certificate && (
                        <div className="error">
                          {errors.turnover_certificate}
                        </div>
                      )}
                      <a href={caCertifcateSample} style={{color:'black', textDecoration: 'underline', fontSize: '14px', display:'block', marginTop:'10px'}} target='_blank' rel='noopener noreferrer'>CA Certificate Sample File</a>
                  </div>
                </div>
              )}
            </div>
          </Form>
        </FormikProvider>
      </div>
      <Footer
        hideBackButton={user_id ? true : false}
        className={user_id ? "justify-content-end" : ""}
        isBackAllowed
        isNextAllowed={loading !== "submit"}
        backButtonAction={() => handleBack()}
        nextButtonText="Next"
        nextButtonAction={() => handleSubmit()}
      />
      {emailModal && (
        <OtpVerifyModal
          footerActionActive={
            otp.length === 4 && loading !== "verify_email_otp"
          }
          footerAction={() => handleVerifyOtp("email")}
          handleCloseModal={() => {
            setEmailModal(false);
            setOtp("");
          }}
          showFooterAction={showEmailVerify}
        >
          <h5 className="modal-title text-center">Verify Email</h5>
          <p className="text-center">
            Your OTP sent on your <br /> email Id {values.email}
          </p>
          <OTPInput
            value={otp}
            onChange={setOtp}
            renderInput={(props) => (
              <div className="form-group">
                <input {...props} />
              </div>
            )}
            containerStyle={"optInputGroups"}
            inputStyle={"form-control"}
            shouldAutoFocus
            placeholder="----"
            inputType="number"
          />
        </OtpVerifyModal>
      )}
      {mobileModal && (
        <OtpVerifyModal
          footerActionActive={
            mobileotp.length === 4 && loading !== "verify_mobile_otp"
          }
          footerAction={() => handleVerifyOtp("mobile")}
          handleCloseModal={() => {
            setMobileModal(false);
            setMobileOtp("");
          }}
          showFooterAction={showMobileVerify}
        >
          <h5 className="modal-title text-center">Verify Number</h5>
          <p className="text-center">
            Your OTP sent on your <br /> Phone Number {values.mobile_number}
          </p>
          <OTPInput
            value={mobileotp}
            onChange={setMobileOtp}
            renderInput={(props) => (
              <div className="form-group">
                <input {...props} />
              </div>
            )}
            containerStyle={"optInputGroups"}
            inputStyle={"form-control"}
            shouldAutoFocus
            placeholder="----"
            inputType="number"
          />
        </OtpVerifyModal>
      )}
    </>
  );
}
